import { render, staticRenderFns } from "./StockResearch.vue?vue&type=template&id=27f49548&scoped=true&"
import script from "./StockResearch.vue?vue&type=script&lang=js&"
export * from "./StockResearch.vue?vue&type=script&lang=js&"
import style0 from "./StockResearch.vue?vue&type=style&index=0&id=27f49548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f49548",
  null
  
)

export default component.exports